<template>
  <div class="distributor-system-set">
    <div class="common-header-wrap">
      <mt-header title="系统设置" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="main-content">
      <div class="form-wrapper">
        <flex-line v-if="chain.store_id" :show-border="true"><span class="line-name">支持自提</span><div slot="right"><mt-switch v-model="chain.chain_if_pickup"/></div></flex-line>
        <flex-line :show-border="true"><span class="line-name">支持代收</span><div slot="right"><mt-switch v-model="chain.chain_if_collect"/></div></flex-line>
      </div>
      <div class="form-wrapper">
          <flex-line class="field-line" :show-border="true"><span class="field-name">代收点名称</span><div class="field-line-right" slot="right"><input class="field-input" v-model="chain.chain_addressname" /></div></flex-line>
          <div @click="onRegion()"><flex-line :is-link="true" :show-border="true"><span class="line-name">所在地</span><span slot="right">{{chain.chain_area_info}}</span></flex-line></div>
          <div @click="popMap=true"><flex-line :is-link="true" :show-border="true"><span class="line-name">详细地址</span><span slot="right">{{chain.chain_address}}</span></flex-line></div>
          <flex-line class="field-line" :show-border="true"><span class="field-name">联系手机</span><div class="field-line-right" slot="right"><input class="field-input" v-model="chain.chain_mobile" /></div></flex-line>
          <flex-line class="field-line" :show-border="true"><span class="field-name">固定电话</span><div class="field-line-right" slot="right"><input class="field-input" v-model="chain.chain_telephony" /></div></flex-line>
      </div>
      <div class="pt-10 pb-10"><div class="common-btn ds-button-large" @click="updateSet">保存</div></div>
    </div>
    
      <div>
          <region-picker ref="picker" @onConfirm="onPickerConfirm"></region-picker>
      </div>
      <div>
          <mt-popup v-model="popMap" position="right" class="common-popup-wrapper">
              <div class="common-header-wrap">
                  <mt-header title="定位" class="common-header">
                      <mt-button slot="left" icon="back" @click="popMap=false"></mt-button>
                  </mt-header>
              </div>
              <div class="common-popup-content">
                  <map-select ref="map_select" :longitude="chain.chain_longitude" :latitude="chain.chain_latitude" @setPosition="setPosition"></map-select>
              </div>
          </mt-popup>
      </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
import RegionPicker from '../../RegionPicker'
import MapSelect from '../../MapSelect'
import { chainInformation, chainSetting } from '../../../api/chainManage'
import { getPointByAddress } from '../../../util/bmap'
import flexLine from '../../flexLine'
export default {
  components:{
    flexLine,
    RegionPicker,
    MapSelect
  },
  name: 'ChainSetting',
  data () {
    return {
      chain: {},
      popMap: false
    }
  },
  mounted () {

  },
  created: function () {
    chainInformation().then(res => {
      this.chain = res.result.chain_info
    }).catch(error => {
      Toast(error.message)
    })
  },

  methods: {
    ...mapMutations({
      memberPoint: 'memberPoint'
    }),
    ...mapMutations({
      chainUpdate: 'chainUpdate'
    }),
    updateSet () {
      chainSetting(this.chain).then(res => {
        this.chainUpdate({ info: res.result.info })
        Toast(res.message)
      }).catch(function (error) {
        Toast(error.message)
      })
    },

    setPosition (lat, lng, name) {
      this.popMap = false
      this.chain.chain_address = name
      this.chain.chain_longitude = lng
      this.chain.chain_latitude = lat
      this.$forceUpdate()
    },
    onPickerConfirm (values) {
      this.chain.chain_area_info = this.getRegionStr(values)
      this.chain.chain_area_2 = values[1] ? values[1].area_id : 0
      this.chain.chain_area_3 = values[2] ? values[2].area_id : 0
      this.selectCity(values.length > 1 ? values[1].area_name : values[0].area_name)
      this.$forceUpdate()
    },
    onRegion () {
      this.$refs.picker.currentValue = true
    },
    getRegionStr (values) {
      let title = ''
      for (let i = 0; i < values.length; i++) {
        const element = values[i]
        if (i !== 0) {
          title = title + ' ' + element.area_name
        } else {
          title = title + element.area_name
        }
      }
      return title
    },
    selectCity (city_name) {
      getPointByAddress(city_name).then(res => {
        if (res.result.location) {
          var lng = res.result.location.lng
          var lat = res.result.location.lat
          this.chain.chain_latitude = lat
          this.chain.chain_longitude = lng

          this.memberPoint({ point: { lng: lng, lat: lat, address: res.result.formatted_address, cityCode: res.result.cityCode, cityName: city_name } })
          // this.$forceUpdate()
        } else {
          Toast('无法获取城市位置')
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
.main-content{background: #fff;padding:0 $pageSpace}
  .distributor-system-set {
    background: #fff;
    .form-wrapper {
      .mint-field-core {
        text-align: right;
      }
      .mint-switch-input:checked + .mint-switch-core {
        border-color: #ff9900 !important;
        background-color: #ff9900 !important;
      }

    }
    .notice {
      font-size:$fontSize;
      color: #999;
      padding: .5rem;
      p {
        position: relative;
        padding-left: .5rem;
      }
      p::before {
        position: absolute;;
        content: '';
        width: .3rem;
        height: .3rem;
        border-radius: 50%;
        background: #ddd;
        display: block;
        top: 50%;
        margin-top: -.15rem;
        left: -.25rem
      }
    }
  }

</style>
